import script from "./RuleSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./RuleSetting.vue?vue&type=script&lang=ts&setup=true"

import "./RuleSetting.vue?vue&type=style&index=0&id=426457e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-426457e8"]])

export default __exports__